import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from '../core/core.module';
import { ReactiveFormsModule } from '@angular/forms';
import { AdHocProductPage } from './ad-hoc-product.page';

@NgModule({
  declarations: [
    AdHocProductPage,
  ],
  imports: [
    CommonModule,
    CoreModule,
    ReactiveFormsModule,
  ],
  exports: [
    AdHocProductPage,
  ]
})
export class AdHocProductModule { }
